import React, { useState } from 'react';
import { Grid, Typography } from '@mui/material';

import './MinPromise.css';
import { Form, FormLabel } from 'react-bootstrap';
import Select from 'react-select';
import { ErrorMessage } from '@hookform/error-message';
import { addTreehouseErrors } from '../../../../constants/error.constants';
import { useForm } from 'react-hook-form';
import FormInput from '../../../common/FormInput';
import { useAuth } from '../../../auth/Auth';
import { campScheduleViewModel } from '../../camp_schedule/camp.schedule.view.model';
import DashboardHeader from '../../../header/DashboardHeader';
import timezones from 'timezones-list';
import { useHistory } from 'react-router-dom';
import LoadButton from '../../../common/LoadButton';
import { GUARDIAN_SETTINGS_ROUTE } from '../../../../constants/routes.constants';

const EditMinPromise = () => {
  const _NOT_SELECTED = '';
  const history = useHistory();
  const { dependent_id } = history?.location?.state;
  const promise_data = history?.location?.state?.promise_data
    ? JSON.parse(history?.location?.state?.promise_data)
    : '';
  const [showPopup, setShowPopup] = useState(true);
  const [day, setDay] = useState(promise_data?.day);
  const [time, setTime] = useState(promise_data?.time);
  const [timezone, setTimezone] = useState(promise_data?.timezone);
  const [isLoading, setIsLoading] = useState(false);
  const { guardian } = useAuth();
  const { register, handleSubmit, setError, errors, getValues } = useForm({
    mode: 'onBlur',
  });
  const dayOptions = [
    { value: _NOT_SELECTED, label: 'Select...' },
    { value: 'sunday', label: 'Sunday' },
    { value: 'monday', label: 'Monday' },
    { value: 'tuesday', label: 'Tuesday' },
    { value: 'wednesday', label: 'Wednesday' },
    { value: 'thursday', label: 'Thursday' },
    { value: 'friday', label: 'Friday' },
    { value: 'saturday', label: 'Saturday' },
  ];

  const customStyles = {
    control: (base) => ({
      ...base,
      height: 48,
      color: '#321b6d',
      fontWeight: '400',
    }),
    singleValue: (provided) => ({
      ...provided,
      color: '#321b6d',
    }),
    menu: (provided) => ({
      ...provided,
    }),
  };

  const handleDayChange = (selected) => {
    setDay(selected.value);
  };

  const onSubmit = () => {
    setIsLoading(true);
    const data = {
      day: day,
      time: time,
      time_zone: timezone,
    };
    campScheduleViewModel
      .updateTwentyMinPromise(promise_data?.id, data)
      .then((res) => {
        setIsLoading(false);
        history.push(GUARDIAN_SETTINGS_ROUTE);
      })
      .catch((err) => {
        console.log(err);
        setIsLoading(false);
      });
  };

  const handleTimezoneChange = (selected) => {
    setTimezone(selected.tzCode);
  };

  const handleTimeChange = (e) => {
    setTime(e.target.value);
  };

  return (
    <div
      className="guardian-setting-wrapper guardian-setting"
      id="guardian_setting"
    >
      <DashboardHeader />
      <div className="container" style={{ paddingTop: '40px' }}>
        <div className="row">
          <div
            className="col-sm-12"
            style={{ display: 'grid', justifyContent: 'center' }}
          >
            <Grid
              container
              direction="column"
              spacing={3}
              justifyContent="center"
              sx={{
                width: { xs: '100%', sm: '600px', md: '700px', lg: '600px' }, // Responsive width
                padding: { xs: '0 16px', sm: '0' },
              }}
            >
              <Grid item>
                <Typography
                  variant="h3"
                  align="left"
                  fontSize="32px"
                  fontWeight="700"
                  color="#321b6d"
                >
                  Select Your Weekly Session Time
                </Typography>
              </Grid>
              <Grid item>
                <Typography
                  variant="h5"
                  fontSize="16"
                  fontWeight="600"
                  color="#321b6d"
                >
                  Let’s make this a consistent, joyful experience.
                </Typography>
              </Grid>
              <Grid item>
                <Typography
                  variant="p"
                  fontSize="14"
                  fontWeight="400"
                  color="#321b6d"
                >
                  Please choose a day and time each week that works best for you
                  and your child to sit down and have this enriching
                  conversation.
                </Typography>
              </Grid>
              <Grid item>
                <Form.Group className="mb-3" controlId="">
                  <Form.Label>Day</Form.Label>
                  <Select
                    options={dayOptions}
                    styles={customStyles}
                    value={dayOptions.filter((obj) => obj.value === day)}
                    theme={(theme) => ({
                      ...theme,
                      borderRadius: '6px',
                      colors: {
                        ...theme.colors,
                        primary: '#80e4e1',
                      },
                    })}
                    onChange={handleDayChange}
                  />
                  <FormInput
                    type="hidden"
                    name="day"
                    value={day}
                    ref={register({
                      required: addTreehouseErrors.day.required,
                    })}
                  />
                  <ErrorMessage
                    errors={errors}
                    name="day"
                    className="small text-danger"
                    as="label"
                  />
                </Form.Group>
              </Grid>
              <Grid item>
                <Form.Group className="mb-3" controlId="">
                  <FormLabel>Time</FormLabel>
                  <FormInput
                    type="time"
                    name="time"
                    className="form-input"
                    value={time}
                    onChange={handleTimeChange}
                    ref={register({
                      required: addTreehouseErrors.time.required,
                    })}
                  />
                  <ErrorMessage
                    errors={errors}
                    name="time"
                    className="small text-danger"
                    as="label"
                  />
                </Form.Group>
              </Grid>
              <Grid item>
                <Form.Group className="mb-3" controlId="">
                  <Form.Label>Time zone</Form.Label>
                  <Select
                    options={timezones}
                    value={
                      timezones[
                        timezones.findIndex((obj) => {
                          return obj.tzCode === timezone;
                        })
                      ]
                    }
                    styles={customStyles}
                    theme={(theme) => ({
                      ...theme,
                      borderRadius: '6px',
                      colors: {
                        ...theme.colors,
                        primary: '#80e4e1',
                      },
                    })}
                    onChange={handleTimezoneChange}
                  />
                  <ErrorMessage
                    errors={errors}
                    name="timezone"
                    className="small text-danger"
                    as="label"
                  />
                </Form.Group>
              </Grid>
            </Grid>
            <Grid container direction="column" alignItems="center" spacing={3}>
              <Grid item width="100%">
                <LoadButton
                  className="Yes_btn"
                  onClick={onSubmit}
                  isLoading={isLoading}
                  isDisabled={!day || !time || !timezone}
                  text="Accept Promise"
                />
              </Grid>
            </Grid>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditMinPromise;
